/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { ListEditsVideoEditorEditsQueryResponse, ListEditsVideoEditorEditsQueryParams } from "../models/ListEditsVideoEditorEdits";

export function getListEditsVideoEditorEditsUrl() {
  const res = { method: 'GET', url: `/video-editor/edits` as const }
  return res
}

/**
 * @summary List edits for the client scoped to a fragment; each item includes creator, published platforms, and rendered video URL when a completed render exists
 * {@link /video-editor/edits}
 */
export async function listEditsVideoEditorEdits(params: ListEditsVideoEditorEditsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListEditsVideoEditorEditsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListEditsVideoEditorEditsUrl().url.toString(), params, ... requestConfig })
  return res.data
}